import { useAuthStore } from '@easy-expense/data-firestore-client';
import React from 'react';

export function useInitAuth() {
  const initAuth = useAuthStore.use.initAuth();
  React.useEffect(() => {
    return initAuth();
  }, []);
}
